/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU Calculator (Relative Synonymous Codon Usage) — Toolverse`)
};

const es_rscu_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de RSCU (Uso Relativo de Codones Sinónimos) — Toolverse`)
};

const de_rscu_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU-Rechner (Relative Synonyme Codon-Nutzung) — Toolverse`)
};

const nl_rscu_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU-calculator (Relative Synonymous Codon Usage) — Toolverse`)
};

const fr_rscu_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur RSCU (usage relatif des codons synonymes) — Toolverse`)
};

const it_rscu_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore RSCU (uso relativo dei codoni sinonimi) — Toolverse`)
};

const pt_br2_rscu_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de RSCU (Uso Relativo de Códons Sinônimos) — Toolverse`)
};

const pt_rscu_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de RSCU (Uso Relativo de Codões Sinónimos) — Toolverse`)
};

const ja_rscu_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU計算ツール（相対同義コドン使用頻度） — Toolverse`)
};

const zh_rscu_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU 计算器（相对同义密码子使用度）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_meta_title", locale)
	if (locale === "en") return en_rscu_meta_title(inputs)
	if (locale === "es") return es_rscu_meta_title(inputs)
	if (locale === "de") return de_rscu_meta_title(inputs)
	if (locale === "nl") return nl_rscu_meta_title(inputs)
	if (locale === "fr") return fr_rscu_meta_title(inputs)
	if (locale === "it") return it_rscu_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_meta_title(inputs)
	if (locale === "pt") return pt_rscu_meta_title(inputs)
	if (locale === "ja") return ja_rscu_meta_title(inputs)
	return zh_rscu_meta_title(inputs)
};